import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_GET_APPLICANT_FILE_URLS } from 'api/actionTypes';

export default async function getApplicantsFileUrls(
  { state, apiClient },
  { householdId, listingId },
) {
  typeCheck('householdId::PositiveNumber', householdId);
  typeCheck('listingId::PositiveNumber', listingId);

  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_APPLICANT_FILE_URLS,
    queryId: `${householdId}-${listingId}`,
    state: state,
    payload: {
      householdId,
      listingId,
    },
  });
}
